export default __webpack_public_path__ + "static/media/Song Of Ice And Fire.52e4174f.png";